// prettier-ignore
import {Component, OnInit, AfterViewInit, OnDestroy, ViewChild, HostListener, NgZone,
  ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { Location } from '@angular/common';
// prettier-ignore
import {Foam, Gravity, Meshing, CloneMaterial, CloneResult, FoamingObj, OpenMold, Part, ProcessData,Simulate,
} from '@usimweb/core/models';

import { C3Service, ModelService } from '@usimweb/ceetron';
import { DialogService, InfoDialogComponent } from '@usimweb/ui/dialogs';
import { Helper, PlotLayout, VtkJsReader } from '@usimweb/core/services';
import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';

import { PlotlyService } from 'angular-plotly.js';
import { timer } from 'rxjs';
import { skip, takeWhile } from 'rxjs/operators';

import { MaterialComponent } from '../components/material/material.component';
import { ProcessDataComponent } from '../components/process-data/process-data.component';
import { OpenMoldComponent } from '../components/open-mold/open-mold/open-mold.component';
import { CloneService } from '../../../core/services/clone-service/clone.service';
import { GeometryService } from '../../../core/services/geometry/geometry.service';

import { FoamingValidation, Validation } from '../../../core/services/validation/foaming.validation';
import { BoundaryConditionsComponent } from '../components/boundary-conditions/boundary-conditions.component';
import { ProcessDialogComponent } from '../../../dialogs/process-dialog/process-dialog.component';

@Component({
    selector: 'app-newfoaming',
    templateUrl: './newfoaming.component.html',
    styleUrls: ['./newfoaming.component.scss'],
    standalone: false
})
export class NewFoamingComponent extends PlotLayout implements OnInit, AfterViewInit, OnDestroy {
  private _modelService: ModelService;
  private project_uuid: string = '';
  private version_uuid: string = '';
  private material: string = '';
  private usimdata: string = '';
  private foaming: FoamingObj = {} as FoamingObj;
  private openMold: OpenMold = {} as OpenMold;
  private moldClosing = {};

  public processData: ProcessData = { injectionRate: 0, targetDensity: 0 };
  public simulate: Simulate = {} as Simulate;
  public part: Part = {} as Part;
  public formGroup!: UntypedFormGroup;
  public title: string | undefined;
  public meshes: Meshing[] = [];
  public foams: Foam[] = [];
  public cpus: {} = {};
  public defaultCpu = 0;
  public credits = 0;
  public selectedMesh: string = '';
  public freeRiseDensity: number | undefined;
  public initialDensity: number | undefined;
  public volume: number = 0;
  public injectionTime: number = 0;
  public gravity: Gravity = { x: 0, y: 0, z: 0 };

  public get modelOpen() {
    return this._modelService.modelOpen;
  }
  public get modelName() {
    return this._modelService.modelName;
  }

  public viewer = 0;
  public isOpenMold = false;
  public isBoundaryPart = false;
  public loadViewerTwo = false;
  public loadViewerThree = false;
  public cadModelChanged = false;
  public isOpenMoldVisible = false;
  public vtkpreview = false;
  public isTaskAlive: boolean = false;
  public isPrevLoading: boolean = false;
  public boundingBoxParts = [];

  @ViewChild('stepper') matStepper!: MatStepper;
  @ViewChild(MaterialComponent) materialComponent!: MaterialComponent;
  @ViewChild(ProcessDataComponent) processDataComponent!: ProcessDataComponent;
  @ViewChild(OpenMoldComponent) openMoldComponent!: OpenMoldComponent;
  @ViewChild(BoundaryConditionsComponent) boundaryConditionsComponent!: BoundaryConditionsComponent;

  constructor(
    private apiService: ApiService,
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private foamingValidation: FoamingValidation,
    private route: ActivatedRoute,
    private location: Location,
    public override snackBar: MatSnackBar,
    public override plotlyService: PlotlyService,
    public c3Service: C3Service,
    public modelService: ModelService,
    public dialogService: DialogService,
    private cloneService: CloneService,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private geometryService: GeometryService
  ) {
    super(plotlyService, snackBar);
    this._modelService = modelService;
  }

  ngOnInit(): void {
    this.project_uuid = this.route.snapshot.paramMap.get('id')?.toString() || '';
    this.initStepper();
    this.foaming.project = this.project_uuid;
  }

  ngAfterViewInit(): void {
    this.loadMeshes();
    this.loadFoams();
    if (this.route.snapshot.paramMap.get('id2')?.toString() || '') {
      const version_uuid = this.route.snapshot.paramMap.get('id2')?.toString() || '';
      this.clone(version_uuid);
    }
  }

  ngOnDestroy() {
    this.isTaskAlive = false;
    this._modelService.clearTask();
  }

  back() {
    this.location.back();
  }

  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  private clone(version_uuid: string) {
    this.dialogService.openBlankDialog(ProcessDialogComponent);
    this.cloneService.clone(this.project_uuid, version_uuid);
    this.cloneService.cloningCallBack.pipe(skip(1)).subscribe((cloneResult: CloneResult) => {
      console.log('clone result');
      console.log(cloneResult);

      if (cloneResult.cloned) {
        this.openModel({ id: version_uuid });
        this.version_uuid = cloneResult.uuid;

        const materialData: CloneMaterial = this.cloneService.getMaterialData();
        this.materialComponent.setMaterialData(materialData);

        const processData: ProcessData = this.cloneService.getProcessData();
        this.processDataComponent.setProcessData(processData);
        this.materialComponent.setMaterialCallBack.pipe(skip(1)).subscribe((finished: boolean) => {
          if (finished) {
            this.dialogService.closeDialog();
          }
        });
      }
    });
  }

  private initStepper(): void {
    this.formGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
      secondCtrl: ['', Validators.required],
    });
  }

  private loadMeshes(): void {
    const subscription = this.apiService.getGeometries(this.project_uuid).subscribe((response: Meshing[]) => {
      subscription.unsubscribe();
      this.meshes = response;
    });
  }

  private loadFoams(): void {
    const subscription = this.apiService.getUsimMaterials('foaming').subscribe((response: Foam[]) => {
      subscription.unsubscribe();
      this.foams = response;
    });
  }

  private getMeasurmentData(slug: string) {
    this.densityViscoChart = [];
    const subscription = this.apiService.getRTData(slug).subscribe((curves) => {
      subscription.unsubscribe();
      this.addCurves(curves);
      this.zone.runOutsideAngular(() => {
        this.addCurves(curves);
        this.calcProcessData(curves);
        setTimeout(() => {
          this.addSimulationLine(60);
          // const meta = curves[1].meta;
          // this.addViscoCreamTime(meta['creamTime']);
          // this.addViscoSolidTime(meta['solidTime']);
          this.cd.detectChanges();
        });
      });
    });
  }

  private calcProcessData(density: [{ y: number[] }]) {
    const y = density[0].y;
    const freeRiseDensity = y.pop() || 0;
    const initialDensity = y[0];

    this.freeRiseDensity = freeRiseDensity;
    this.initialDensity = initialDensity;
  }

  private getPreview(uuid: string) {
    const subscription = this.apiService.getGeometriePreview(uuid, 'vtkjs').subscribe((response) => {
      subscription.unsubscribe();

      this.vtkpreview = false;

      let divElement = document.getElementById('vtkjsPreviewDiv');
      if (divElement) {
        this.vtkpreview = VtkJsReader.loadfile(divElement, response);
      }

      let calledOpenMoldPreview = false;
      let calledBoundaryPreview = false;

      //FIXME pipe take one to solve mulitple ceetron calls???
      VtkJsReader.isRendering.pipe().subscribe((isRendering: boolean) => {
        this.isPrevLoading = isRendering;

        if (this.isOpenMold && !calledOpenMoldPreview) {
          this.openMoldComponent.previewLoadModel(uuid);
          calledOpenMoldPreview = true;
        }

        // if (!calledBoundaryPreview) {
        //   this.boundaryConditionsComponent.previewLoadModel(uuid);
        //   calledBoundaryPreview = true;
        // }
      });
    });
  }

  public addSimulationTime(value: number): void {
    this.credits = (this.part.credits || 0) + 100 + this.simulate.simulationTime * 1.2;
    this.addSimulationLine(value);
  }

  public addTargetDensity(value: number): void {
    this.addTargetDensityLine(value);
  }

  public addInjectionTime(value: number): void {
    this.injectionTime =
      Math.round(((this.volume * this.processData.targetDensity) / this.processData.injectionRate) * 1e4) / 1e4;
    this.addInjectionTimeLine(value);
  }

  public updatePart(part: Part): void {
    this.part = part;
  }

  public updateMaterial(material: string) {
    this.material = material;
  }

  public updateProcessData(processData: ProcessData): void {
    this.processData = processData;
  }

  public updateOpenMold(openMold: OpenMold) {
    this.openMold = openMold;
  }

  public updateSimulate(simulate: Simulate): void {
    this.simulate = simulate;
  }

  public drawPlot(slug: string): void {
    this.usimdata = slug;
    this.getMeasurmentData(slug);
  }

  public moldClosingChanged(data: {}) {
    this.moldClosing = data;
  }

  public openModel(event: { id: string }): void {
    this.isPrevLoading = true;
    const uuid = event['id'];
    this.getPreview(uuid);

    this.foaming.mesh = uuid;
    this.version_uuid = uuid;

    const subscriptionMesh = this.apiService.getGeometryById(uuid).subscribe((mesh: Meshing) => {
      subscriptionMesh.unsubscribe();

      this.gravity.x = mesh.gravityX || 0;
      this.gravity.y = mesh.gravityY || 0;
      this.gravity.z = mesh.gravityZ || 0;

      this.part = {
        modelKey: mesh.id,
        cadModel: mesh.title,
        gravityX: mesh.gravityX,
        gravityZ: mesh.gravityZ,
        gravityY: mesh.gravityY,
        volume: mesh.volume,
        credits: mesh.credits,
      } as Part;
      this.simulate.appType = mesh.appType;

      this.credits = (this.part.credits || 0) + 100 + this.simulate.simulationTime * 1.2;
      this.simulate.credits = this.credits;

      this.cpus = mesh.ncpus || this.cpus;
      this.defaultCpu = parseFloat(Helper.Array.findValueByKey(mesh.ncpus, 'default') || '0');
      this.volume = mesh.volume || 0;

      this.isOpenMold =
        mesh.appType.endsWith('-open') || mesh.appType.endsWith('_open') || mesh.appType.includes('porousBox')
          ? true
          : false;
      this.cadModelChanged = true;
    });
  }

  public getGeometry(event: any) {
    this.isTaskAlive = true;
    this.snackBar.open('Started meshing....', 'OK', { duration: 2000 });

    this.matStepper.selectedIndex = 1;

    this.meshes.push({
      id: event.id,
      title: event.title + ' (In process)',
      stlFile: event.file,
      appType: event.appType,
      modelKey: '',
    });
    this.selectedMesh = event.id;

    timer(0, 3000)
      .pipe(takeWhile(() => this.isTaskAlive))
      .subscribe(() => {
        const subscriptionMesh = this.apiService.getGeometryById(event.id).subscribe((response) => {
          subscriptionMesh.unsubscribe();

          const progress = response['progress'];
          if (progress == 100) {
            this.isTaskAlive = false;

            const subscriptionMeshes = this.apiService
              .getGeometries(this.project_uuid)
              .subscribe((meshing: Meshing[]) => {
                subscriptionMeshes.unsubscribe();

                for (let i = 0; i < meshing.length; i++) {
                  if (meshing[i].uuid === event.id) {
                    this.meshes = meshing;
                    this.selectedMesh = event.id;
                  }
                }

                this.openModel(event);
                this.snackBar.open('Finished meshing....', 'OK', {
                  duration: 2000,
                });
              });
          }
        });
      });
  }

  public openStartSimulationDialog(): void {
    this.foaming.title = this.simulate.name;
    this.foaming.owner = AuthHandler.basfUserName;
    this.foaming.gravityX = this.part.gravityX;
    this.foaming.gravityY = this.part.gravityY;
    this.foaming.gravityZ = this.part.gravityZ;
    this.foaming.injectionRate = this.processData.injectionRate;
    this.foaming.targetDensity = this.processData.targetDensity;
    this.foaming.nCpus = this.simulate.cpus;
    this.foaming.simulationTime = Number(this.simulate.simulationTime);
    this.foaming.outputTime = Number(this.simulate.outPutTime);
    this.foaming.appType = this.simulate.appType;
    this.foaming.matdata = this.usimdata;
    let isOpenMold = false;
    if (this.openMold && this.moldClosing) {
      this.openMold.moldClosing = this.moldClosing;
    }
    if (this.isOpenMold) {
      this.foaming.openMold = this.openMold;
      isOpenMold = true;
    }
    const validation = this.foamingValidation.checkValidation(
      this.material,
      this.usimdata,
      this.foaming,
      isOpenMold
    ) as Validation;
    if (validation.isValid) {
      this.dialogService
        .openDialog(
          InfoDialogComponent,
          undefined,
          'Start simulation',
          'Start',
          'Are you sure you want to start the simulation?'
        )
        .subscribe((result: any) => {
          if (result) {
            const subscription = this.apiService.addFoamingVersion(this.foaming, this.version_uuid).subscribe(() => {
              subscription.unsubscribe();
              this.router.navigate(['app/versions/' + this.project_uuid]);
            });
          }
        });
    } else {
      this.matStepper.selectedIndex = validation.index;
    }
  }
}
